import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type AttendanceInvalidation = { practiceId: number; leadId?: number; treatmentId?: number; appointmentId?: number };
// Invalidation is practice-scoped; no patient content or callbacks are persisted.
const slice = createSlice({
    name: 'attendanceReview',
    initialState: { revisions: {} as Record<string, number> },
    reducers: {
        invalidateAttendance(state, action: PayloadAction<AttendanceInvalidation>) {
            const key = String(action.payload.practiceId);
            state.revisions[key] = (state.revisions[key] || 0) + 1;
        },
    },
});
export const { invalidateAttendance } = slice.actions;
export default slice.reducer;
